import $ from 'jquery/src/jquery';
import { tns } from 'tiny-slider';
import 'tiny-slider/src/tiny-slider.scss';

$(document).ready(function($) {
    $('.slider').each(function(index, element) {
        const $carousel = $(element);
        const $container = $carousel.find('[class*="__slides"]');
        const slider = tns({
            container: $container[0],
            loop: true,
            gutter: 30,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayHoverPause: true,
            autoplayTimeout: 5000,
            nav: false,
            navPosition: 'bottom',
            controls: true,
            controlsText: ['', ''],
            controlsPosition: 'bottom',
            autoHeight: false,
            mouseDrag: true,
        });
        slider.events.on('dragStart', function() {
            slider.pause();
        });
        slider.events.on('dragMove', function() {
            slider.pause();
        });
        slider.events.on('dragEnd', function() {
            slider.pause();
        });
    })
});